import {
  DESIGNER_IMPORT_CSV_IRI,
  DESIGNER_IMPORT_FILENAME_IRI,
  RDFS_LABEL_IRI,
  SCHEMA_ORG_DATE_PUBLISHED_IRI,
  XSD_DATE_TIME_IRI,
} from 'src/templates/queries/iris';
import { escapeDoubleQuotes } from 'src/utils/escapeDoubleQuotes';

export const stringifyProjectMetadata = (
  namedGraph: string,
  label: string,
  publishedDate: number,
  filename?: string
) => {
  const isoDate = new Date(publishedDate).toISOString();
  return `\
<${namedGraph}> {
  <${namedGraph}> ${
    filename
      ? `
    a <${DESIGNER_IMPORT_CSV_IRI}> ;
    <${DESIGNER_IMPORT_FILENAME_IRI}> "${escapeDoubleQuotes(filename)}" ;`
      : ''
  }
    <${RDFS_LABEL_IRI}> "${escapeDoubleQuotes(label)}" ;
    <${SCHEMA_ORG_DATE_PUBLISHED_IRI}> "${isoDate}"^^<${XSD_DATE_TIME_IRI}> .
}`;
};
